import React from 'react';
import { DateInput } from 'react-admin-date-inputs';

import { UiBaseInput } from './BaseInput';

export const UiDateInput = (props) => <UiBaseInput component={DateInput} {...props} />;
